import * as React from 'react';

import { IMemberTableRefHandles } from '@frontend/app/components';
import { ISocialAccount } from '@components';

const { createContext } = React;

interface IProspectsListContext {
  tableRef: React.RefObject<IMemberTableRefHandles>,
  socialProfileMap: Record<string, ISocialAccount>,
  isFetchingSocialData: boolean,
  updateSocialProfileMap: (socialProfileMap: Record<string, ISocialAccount>) => void,
  setIsFetchingSocialData: (isFetchingSocialData: boolean) => void,
}

interface IProspectsListContextProviderProps {
  tableRef: React.RefObject<IMemberTableRefHandles>,
  socialProfileMap?: Record<string, ISocialAccount>,
  isFetchingSocialData?: boolean,
}

export const ProspectsListContext = createContext<IProspectsListContext>(null);

export const ProspectsListContextProvider: React.FC<IProspectsListContextProviderProps> = (props) => {
  const { children, ...context } = props;

  const [socialProfileMap, setSocialProfileMap] = React.useState<Record<string, ISocialAccount>>(context.socialProfileMap || {});

  const [isFetchingSocialData, setIsFetchingSocialData] = React.useState(context.isFetchingSocialData || false);

  const updateSocialProfileMap = React.useCallback((newSocialProfileMap: Record<string, ISocialAccount>) => {
    setSocialProfileMap((prevSocialProfileMap) => ({ ...prevSocialProfileMap, ...newSocialProfileMap }));
  }, []);

  const value: IProspectsListContext = React.useMemo(() => ({
    ...context,
    socialProfileMap,
    isFetchingSocialData,
    updateSocialProfileMap,
    setIsFetchingSocialData,
  }), [context, socialProfileMap, isFetchingSocialData, updateSocialProfileMap]);

  return (
    <ProspectsListContext.Provider value={value}>
      {children}
    </ProspectsListContext.Provider>
  );
};

export const useProspectsListContext = () => {
  return React.useContext(ProspectsListContext);
};
